import { orderIterations } from 'common/utils/utils';
import useWorkingDaysSettings from 'views/root/views/home/hooks/useWorkingDaysSettings';
import { getSearchRangesFromFilters } from '../utils/common';

const DEFAULT_LAST_ITERATIONS = Array.from(
  { length: 10 },
  (_, index) => `Last ${index + 1} Iterations`
);

const useSearchRanges = ({ filters, iterations }) => {
  const workingDaysSetting = useWorkingDaysSettings({
    teams: filters.selectedTeams || filters.globallySelectedTeams
  });

  const orderedIterations = orderIterations(
    iterations.filter(({ name }) => !DEFAULT_LAST_ITERATIONS.includes(name))
  );

  const timeRange = getSearchRangesFromFilters({
    orderedIterations,
    filters,
    workingDaysSetting
  });

  const searchRange = getSearchRangesFromFilters({
    orderedIterations,
    filters,
    workingDaysSetting,
    forSearch: false
  });
  return {
    searchRange,
    timeRange
  };
};

export default useSearchRanges;
